import { Button } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { NavBar } from "../../Models/NavBar/NavBar.Model";
import { useSwivlNavigate } from "../../Models/NavBar/useSwivlNavigate";

export function DashboardView() {
  const navigate = useSwivlNavigate();

  useEffect(() => {
    NavBar.set(null, <NavBar.Component.Logo />);
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="flex max-w-[400px] flex-col justify-center gap-4 rounded-md bg-white p-4 text-left">
        <h1 className="font-bold">📈 Dashboard has a new home 📊</h1>
        <div>
          <p className="text-sm">
            You&apos;ll now find Analytics in a dedicated tab within{" "}
            <Link className="text-orange-500" to="/properties">
              Property Manager
            </Link>
            , making it faster and easier to access the insights that matter most. Along with the move, we&apos;ve rolled out richer, more actionable
            reports designed to help you understand performance at every level.
          </p>
        </div>
        <div className="text-sm">
          <p className="font-bold">What's new:</p>
          <ul className="list-disc pl-5">
            <li>Real-time states to track performance as it happens</li>
            <li>Deeper, more detailed reporting for better insights</li>
            <li>Drill down to the group and location level for precise analysis</li>
            <li>Export reports to share data outside the platform</li>
          </ul>
        </div>
        <div className="flex flex-col items-center gap-4">
          <Link
            className="transition-colors duration-200 ease-in-out hover:outline-orange-500"
            to="https://www.youtube.com/watch?v=mCFWBQWL31Y"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Reports Overview"
              width="368"
              height="206"
              src="https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/reports-new-home-video-thumbnail.png"
            />
          </Link>
          <Button
            onClick={() => {
              navigate("/properties/page/reports/engagement/88e502f5");
            }}
          >
            See my reports!
          </Button>
        </div>
      </div>
    </div>
  );
}
